import React from 'react'
import Svg from './Svg'
import Bg from './Bg'
import CircleBg from './CircleBg'
import Texts from './Texts'
import DataItems from './DataItems'

export default function Circle (props) {
  return (
    <>
      {props.percentage !== '' &&
        <div className='mtt-ttmzero-circle__circle-wrapper'>
          <div className='mtt-ttmzero-circle__circle-inner'>
            <Svg svg={props.circle_image.svg} />            
            <CircleBg percent={props.percentage} />
            <Texts percent={props.percentage} text={props.percentage_text} />
            <DataItems {...props} />
          </div>
        </div>}
    </>
  )
}
